export interface MultiGetResponse<T> {
  data: T[];
  filtered_count_map: Record<string, number>;
}

export interface MultiGetChildResponse<T> {
  data: T[];
}

export enum PaymentsPartnerCountry {
  USA = "US",
  UK = "GB",
  Canada = "CA"
}

export enum ViewGeneratorKey {
  AllContacts = "contacts:all",
  AvailablePaymentMethodsCounts = "available_payment_methods_counts:all",
  AllowedPaymentMethods = "allowed_payment_methods:all",
  Country = "country:all",
  AllWhitelists = "whitelists:all",
  AdyenTransaction = "adyen_transaction",
  LastMandateRequestSent = "last_mandate_request_sent"
}

export interface KeyValue {
  key: string;
  value: string;
}

export const validateEmail = (value: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};

export const validateDomain = (value: string): boolean => {
  const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return domainRegex.test(value);
};

export const capitalizeAfterSpace = (value?: string): string => {
  if (!value) return "";
  const words = value.split(" ");
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};

export const capitalizeAfterUnderscore = (value?: string): string => {
  if (!value) return "";
  const words = value.split("_");
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
